import { useCallback, useEffect, useRef, useState } from "react";
import { ApiError } from "../../api.js";

// Автозбереження редактора (як у майстрі ПН): послідовно, з поточною версією; конфлікт (інша вкладка) — повідомляємо,
// не перезаписуємо. send(value, version) → нова версія
export function useAutosave(send, initialVersion) {
  const [save, setSave] = useState({ state: "saved" });
  const version = useRef(initialVersion), pending = useRef(null), saving = useRef(false), timer = useRef(null);
  useEffect(() => { version.current = initialVersion; }, [initialVersion]);
  const flush = useCallback(async () => {
    if (saving.current || !pending.current) return;
    saving.current = true;
    const v = pending.current; pending.current = null;
    setSave({ state: "saving" });
    try {
      version.current = await send(v, version.current);
      setSave({ state: "saved", at: new Date() });
    } catch (e) {
      setSave({ state: "error", error: e, conflict: e instanceof ApiError && e.status === 409 && !/номер/i.test(e.message) });
    } finally {
      saving.current = false;
      if (pending.current) flush();
    }
  }, [send]);
  const queue = useCallback((v) => {
    pending.current = v;
    clearTimeout(timer.current); timer.current = setTimeout(flush, 600);
    setSave((s) => (s.state === "error" && s.conflict ? s : { state: "dirty" }));
  }, [flush]);
  const flushNow = useCallback(async () => {
    clearTimeout(timer.current);
    await flush();
    while (saving.current || pending.current) { await new Promise((r) => setTimeout(r, 60)); if (!saving.current) await flush(); }
  }, [flush]);
  useEffect(() => () => clearTimeout(timer.current), []);
  return { save, queue, flushNow, version };
}

export function SaveState({ save }) {
  if (save.state === "saving" || save.state === "dirty") return <span className="muted small" aria-live="polite">зберігаємо…</span>;
  if (save.state === "error") return save.conflict
    ? <span className="error small" role="alert">змінено в іншій вкладці — <button type="button" className="linkish" onClick={() => location.reload()}>оновити</button></span>
    : <span className="error small" role="alert">не збережено: {save.error.message}</span>;
  return <span className="muted small" aria-live="polite">збережено{save.at ? ` о ${save.at.toLocaleTimeString("uk-UA", { hour: "2-digit", minute: "2-digit" })}` : ""}</span>;
}
